import {
  GET_THRESHOLD_SUCCESS,
  GET_THRESHOLD_FAIL,
  GET_THRESHOLD,
  GET_DYNAMIC_THRESHOLD_SUCCESS,
  GET_DYNAMIC_THRESHOLD_FAIL,
  GET_SERVICE_QUOTA_THRESHOLD_SUCCESS,
  GET_QUOTA_MASTER_RESOURCES_SUCCESS,
  GET_DEPLOYED_SERVICE_QUOTA_ALERTS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  threshold: [],
  dynamic_threshold: [],
  service_quota_threshold: {},
  quota_master_resources: [],
  deployed_service_quota_alerts: [],
};

const Threshold = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_THRESHOLD_SUCCESS:
      return {
        ...state,
        threshold: action.payload,
      }

    case GET_THRESHOLD_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DYNAMIC_THRESHOLD_SUCCESS:
      return {
        ...state,
        dynamic_threshold: action.payload,
      }

    case GET_DYNAMIC_THRESHOLD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_SERVICE_QUOTA_THRESHOLD_SUCCESS:
      return {
        ...state,
        service_quota_threshold: action.payload,
      }

    case GET_QUOTA_MASTER_RESOURCES_SUCCESS:
      return {
        ...state,
        quota_master_resources: action.payload,
      }
    case GET_DEPLOYED_SERVICE_QUOTA_ALERTS_SUCCESS:
      return {
        ...state,
        deployed_service_quota_alerts: action.payload,
      }
    default:
      return state
  }
}


export default Threshold;